import {useCallback, useReducer} from 'react'
import {getGroupActionFields} from './actions'
import Reducer, {InitialState} from './reducer'

export const useGetGroupActionFields = () => {
  const [state, dispatch] = useReducer(Reducer, InitialState)

  const call = useCallback(
    ({group_id, action_id, type = null, all_fields = false}) => {
      getGroupActionFields(dispatch, {group_id, action_id, type, all_fields})
    },
    [dispatch]
  )

  return {state, dispatch, call}
}
